"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIcon = exports.getErrorDetails = exports.getType = exports.getText = exports.getIsDialogOpen = exports.getIsSnackbarOpen = exports.getVariant = exports.getIsOpen = void 0;

var _reselect = require("reselect");

var getIsOpen = function getIsOpen(state) {
  return state.globalMessage.isOpen;
};

exports.getIsOpen = getIsOpen;

var getVariant = function getVariant(state) {
  return state.globalMessage.variant;
};

exports.getVariant = getVariant;
var getIsSnackbarOpen = (0, _reselect.createSelector)(getIsOpen, getVariant, function (isOpen, variant) {
  return isOpen && variant === 'snackbar';
});
exports.getIsSnackbarOpen = getIsSnackbarOpen;
var getIsDialogOpen = (0, _reselect.createSelector)(getIsOpen, getVariant, function (isOpen, variant) {
  return isOpen && variant === 'dialog';
});
exports.getIsDialogOpen = getIsDialogOpen;

var getText = function getText(state) {
  return state.globalMessage.message;
};

exports.getText = getText;

var getType = function getType(state) {
  return state.globalMessage.type;
};

exports.getType = getType;

var getErrorDetails = function getErrorDetails(state) {
  return state.globalMessage.errorDetails;
};

exports.getErrorDetails = getErrorDetails;

var getIcon = function getIcon(state) {
  return state.globalMessage.icon;
};

exports.getIcon = getIcon;